import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding: 16px 12px;
  width: 100%;
  justify-self: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.purple7};
  color: ${({ theme }) => theme.colors.white};
  margin: 0 8px;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.2px;
  text-align: center;
`;

export const Subtitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
`;

export const ItemsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  align-items: center;
  width: 100%;
  margin-top: 8px;
  i {
    font-size: 72px;
    fill: ${({ theme }) => theme.colors.white};
    cursor: pointer;
  }

  .IconFaceSatisfied:hover {
    fill: ${({ theme }) => theme.colors.green6};
  }
  .IconFaceSatisfiedFilled {
    fill: ${({ theme }) => theme.colors.green6};
  }
  .IconFaceNeutral:hover {
    fill: ${({ theme }) => theme.colors.orange6};
  }
  .IconFaceNeutralFilled {
    fill: ${({ theme }) => theme.colors.green6};
  }
  .IconFaceDissatisfied:hover {
    fill: ${({ theme }) => theme.colors.red6};
  }
  .IconFaceDissatisfiedFilled {
    fill: ${({ theme }) => theme.colors.green6};
  }
`;
